import { keysOf } from './core.js';
// ── status ─────────────────────────────────────────────────────────────────
/**
 * What someone's up to (FR-STA-01); the hints are the status picker's. The icon is the badge on the
 * top left of their user icon (docs/USER-ICONS.md IC-04); browsing has none. POSTGRES ENUM status_kind.
 */
export const STATUS_KIND_OPTIONS = {
    looking: { label: 'Looking', hint: 'now, today or tonight', icon: 'eye' },
    hosting: { label: 'Hosting', hint: "door's open", icon: 'house' },
    at_spot: { label: 'At a spot', hint: 'check in somewhere', icon: 'marker' },
    travelling: { label: 'Traveling', hint: 'heading somewhere', icon: 'plane' },
    browsing: { label: 'Just browsing', short: 'Browsing', hint: 'clear your status' },
};
/** When "Looking" is for; how long each lasts is LOOKING_HOURS. Checked in code. */
export const LOOKING_WHEN_OPTIONS = {
    now: { label: 'Now' },
    today: { label: 'Today' },
    tonight: { label: 'Tonight' },
};
/** What a host can say about their place (FR-STA-01). Checked in code. */
export const HOSTING_TAG_OPTIONS = {
    discreet: { label: 'Discreet' },
    groups_ok: { label: 'Groups ok' },
    come_now: { label: 'Come now' },
    shower: { label: 'Shower here' },
};
export const HOSTING_TAGS = /* @__PURE__ */ keysOf(HOSTING_TAG_OPTIONS);
//# sourceMappingURL=status.js.map